import React from 'react'
import PropTypes from 'prop-types'
import { ACAnswerNode, ACAnswerNodeLabel, ACClosedIcon, ACOpenedIcon } from '../styledComponents'
import emptyCircleIcon from '../../../images/Autocode/empty_circle.svg';
import selectedCircleIcon from '../../../images/Autocode/empty_circle_selected.svg'

const ACTreeAnswerNode = ({
  node = {},
  nodeClickHandler,
  level
}) => (
  <ACAnswerNode isSelected={node.isSelected} onClick={nodeClickHandler} level={level}>
    {!node.isSelected && <ACClosedIcon src={emptyCircleIcon} alt="Closed Icon" />}
    {node.isSelected && <ACOpenedIcon src={selectedCircleIcon} alt="Opened Icon" />}
    <ACAnswerNodeLabel>{node.shortText}</ACAnswerNodeLabel>
  </ACAnswerNode>
)

ACTreeAnswerNode.propTypes = {
  node: PropTypes.shape({}),
  nodeClickHandler: PropTypes.func,
  level: PropTypes.number
}

export default ACTreeAnswerNode
